<template>
  <TemplateBasic
    class="basic"
    cloud
    space
    :showModal="showModal"
    :key="$route.name"
    @close="closeModal"
  >

    <template v-slot:body>
      <ThumbnailZoom v-if="src.length" :src="src" />

    <div class="customize-product wrap">
      <slot name="title" class="col-big-vbspace">
        <p class="big-title" ref="title">{{ type }}</p>
        <p v-html="description"></p>
      </slot>

      <div class="customize-product__content" v-if="ready">
        <ChooseStep
            :steps="steps"
            :active-step="activeStep"
            :photo-option="photoOption"
            @set-active="chooseStep"
          />

        <div class="col-xs-12 col-vspace error-message" v-show="wrongChar || wrongCharTwins">
          <p>Attention, le caractère que vous avez essayé d'entrer n'est pas pris en compte.</p>
        </div>

        <div class="col-xs-12 col-vspace error-message" v-show="tooLong || tooLongTwins">
          <p>
            Attention, le nombre de caractères maximum est limité à
            {{ maxLength }}. Pour des commandes personnalisées,
            <Router-Link to="/contact" tag="a">
              contactez-nous
            </Router-Link>
          </p>
        </div>

        <div class="content-step">
          <div
            class="content-step--twins__preview"
            v-show="activeStep === 0 || activeStep === 2 || activeStep === 3"
          >
            <transition name="fade" appear>
              <div ref="preview"></div>
            </transition>

            <transition name="fade" appear>
              <div ref="previewSecond"></div>
            </transition>
          </div>

          <transition name="translate" mode="out-in">
            <div class="content-step--twins__preview__name" v-show="activeStep === 0" >
              <BasicPreviewName
                :name="product.name"
                :typo="product.typo.name"
                @change-name="changeName"
                @handle-error="handleError"
              />

              <BasicPreviewName
                :name="product.name2"
                :typo="product.typo.name"
                @change-name="changeNameBis"
                @handle-error="handleErrorTwins"
              />

              <BasicFontChoice
                class="row col-hspace"
                :twins="true"
                :name="product.name"
                :nameTwin="product.name2"
                :typos="typos"
                :active="product.typo"
                @change-typo="changeTypo"
                />
              </div>
          </transition>


          <transition name="translate" mode="out-in">
            <div v-show="activeStep === 1">
              <div class="row col-hspace form-classic">
                <div class="col-xs-12 col-big-vspace">
                  <label class="alone-label" for="date-infinite">Date</label>

                  <DatePicker v-model="product.date" big />
                </div>
              </div>

            </div>
          </transition>

          <transition name="translate" mode="out-in">
            <BasicColorChoice
              class="row col-hspace"
              :colors="colors"
              :active="product.color"
              v-show="activeStep === 2"
              @change-color="changeColor"
              @hover-color="hovered"
              />
          </transition>

          <transition name="translate" mode="out-in">
            <BasicSizeChoice
              class="row col-hspace"
              :sizes="objectWidth"
              :active="product.width"
              v-show="activeStep === 3"
              @change-size="changeSize"
              />
          </transition>

          <transition name="translate" mode="out-in">
            <div class="row col-hspace" v-show="activeStep === 4">
              <div class="tleft-child col-space m-auto boxed-content">
                <ProductSummary :product="product" />
              </div>

              <div class="col-xs-12">
                <div class="col-xs-12">
                  <div class="col-vtspace" >
                    <p class="col-small-vbspace">Quantité</p>
                    <Quantity
                      :key="key"
                      :quantity="product.quantity"
                      @quantity="changeQty"
                    />
                  </div>
                </div>
              </div>
              <div class="col-xs-12">
                <p class="price"><span>{{ priceTotal }}</span>&euro;</p>
              </div>
              <div class="col-xs-12 col-vtspace">
                <button
                  type="button"
                  class="btn btn-valid add-to-cart"
                  :class="cartAnimation ? 'active' : 'inactive'"
                  @click="sendDatas"
                >
                  <transition name="cart-out" mode="out-in">
                    <span v-if="!cartAnimation">
                      <i class="fa fa-shopping-bag"></i> Ajouter au panier
                    </span>
                  </transition>
                  <transition name="cart-in" mode="out-in">
                    <span v-if="cartAnimation">
                      <i class="fa fa-check"></i> Ajouté
                    </span>
                  </transition>
                </button>
              </div>
            </div>
          </transition>

          <transition name="fade">
            <section
              v-show="activeStep < (steps.length - 1)"
              class="content-step__next col-hspace fade-h40"
            >
              <button
                type="button"
                class="content-step__next__button"
                @click.prevent="chooseStep(activeStep + 1)"
              >
                <span>Passer à l'étape suivante <i class="tsmall fa fa-chevron-right"></i></span>
              </button>
              <div class="price-step">
                <p class="price">
                  <span v-if="priceTotal === 0">àpd. 10</span>
                  <span v-else>{{ priceTotal }}</span>
                  &euro;</p>
              </div>
            </section>
          </transition>
        </div>
      </div>
    </div>

    <div class="product-info col-xs-12 bg-silver">
      <div class="wrap row">
        <div class="col-xs-12 tleft-child col-big-vspace">
          <p class="sub-title tblack bold col-vbspace">Description</p>
          <p>
            <span class="bold tblack">3 tailles disponibles : </span>
            <ul class="basic-list tleft-child">
              <li>- 20cm de long, environ 7,5cm de haut et 8mm d'épaisseur</li>
              <li>- 25cm de long, environ 9,5cm de haut et 1cm d'épaisseur</li>
              <li>- 30cm de long, environ 11cm de haut et 1,4cm d'épaisseur</li>
            </ul>
          </p>

          <p>
            <span class="bold tblack">Matière : </span>
            Les décorations infini sont en PLA, un bio-plastique léger fait à partir d'amidon de maïs.
          </p>

          <p>
            <span class="bold tblack">Précaution : </span>
            Les objets 3D en PLA ne peuvent pas être exposés à une forte chaleur, cela risquerait de les déformer.
          </p>

          <p class="col-big-vtspace">
            <router-link
              class="link-classic"
              target="_blank"
              tag="a"
              :to="{name: 'colors'}"
            >
              Retrouvez notre guide des couleurs ici.
            </router-link>
          </p>
        </div>
      </div>
    </div>

    <WidddiFlux :tags="tags">

      <template v-slot:title>
        <p class="sub-title tblack bold">Un petit peu d'inspiration...</p>
      </template>

    </WidddiFlux>

    <section class="col-big-vspace">
      <WidddiSocials>
        <p>Retrouvez plus de photos</p>
        <p>sur notre page facebook et notre compte instagram !</p>
      </WidddiSocials>
    </section>

    </template>
  </TemplateBasic>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  BasicPreviewName,
  BasicFontChoice,
  BasicColorChoice,
  BasicSizeChoice,
} from '@/components/customize/templates';
import { Quantity, DatePicker, ProductSummary } from '@/components/utils';
import {
  arrActions,
  formatDate,
  sizeActions,
  previewName,
  productActions,
} from '@/mixins';
import { TemplateBasic } from '@/components/template';
import { ChooseStep, WidddiSocials, WidddiFlux, ThumbnailZoom } from '@/components/template/Elements';

import Colors from '@/utils/products/colors.json';
import Options from '@/utils/products/infinite/options.json';
import Typos from '@/utils/products/infinite/typos.json';
import Size from '@/utils/products/infinite/size.json';

export default {
  props: {
    type: {
      type: String,
      default: 'Produit',
    },

    tags: {
      type: Array,
      default: () => [],
    },

    description: {
      type: String,
      default: 'Produit',
    },

    hiddenType: {
      type: String,
      default: 'basic',
    },

    src: {
      type: String,
      default: '',
    },
  },

  components: {
    ChooseStep,
    BasicPreviewName,
    BasicFontChoice,
    BasicColorChoice,
    BasicSizeChoice,
    Quantity,
    TemplateBasic,
    WidddiSocials,
    WidddiFlux,
    DatePicker,
    ProductSummary,
    ThumbnailZoom,
  },

  mixins: [
    arrActions,
    formatDate,
    sizeActions,
    previewName,
    productActions,
  ],

  data() {
    return {
      product: {
        type: 'Décoration infini',
        options: [],
        typo: { name: 'hh', title: 'Police n°1' },
        color: { name: 'light-pink', title: 'Rose pastel', hexa: '#f9e0e1' },
        width: {
          name: 'w20',
          title: '20cm de long',
          value: 20,
          price: 0,
        },
        name: 'Widddi',
        name2: 'Widddi',
        quantity: 1,
        date: this.prettyDate(Date.now()),
        message: '',
      },
      objectWidth: [],
      steps: [
        { number: '1', name: 'Prénoms' },
        { number: '2', name: 'Date' },
        { number: '3', name: 'Couleur' },
        { number: '4', name: 'Taille' },
        { number: '5', name: 'Panier' },
      ],
      maxLength: 10,
      itemsToShow: 3,
    };
  },

  created() {
    this.colors = JSON.parse(JSON.stringify(Colors));
    this.options = JSON.parse(JSON.stringify(Options));
    this.typos = JSON.parse(JSON.stringify(Typos));
    this.objectWidth = JSON.parse(JSON.stringify(Size));

    this.$set(this.product, 'type', this.type);
    this.$set(this.product, 'options', []);
    this.$set(this.product, 'hiddenType', this.hiddenType);
  },

  computed: {
    ...mapGetters({
      priceInfinite: 'shop/priceInfinite',
    }),

    productPrice() {
      return this.priceInfinite[this.product.width.value];
    },

    optionDate() {
      return this.options.filter(option => option.name === 'date' || option.name === 'no-date');
    },

    showDateInput() {
      return this.product.options.filter(option => option.name === 'date').length === 1;
    },
  },
  methods: {
    changeSize(size) {
      this.product.width = { name: size.name, title: size.title, value: size.value };

      this.$nextTick(() => this.changePreviewSize());
    },

    checkOption(name, shortname) {
      const idOption = this.findIndexInData(this.options, 'name', name);
      const isAlready = this.findIndexInData(this.product.options, 'shortname', shortname);

      if (isAlready > -1) {
        this.product.options.splice(isAlready, 1);
      }

      if (name === 'no-date') {
        this.product.date = null;
      }

      this.$nextTick(() => {
        this.product.options.push(this.options[idOption]);
      });
    },

    triggerPreview(loading = false) {
      const target = [
        { name: this.product.name, container: this.$refs.preview },
        { name: this.product.name2, container: this.$refs.previewSecond },
      ];

      this.drawCanvas({
        target,
        name: this.product.name,
        typo: this.product.typo.name,
        color: this.product.color.hexa,
        width: this.product.width.value,
        loading,
      });
    },

    changePreviewSize() {
      [
        this.$refs.preview,
        this.$refs.previewSecond,
      ].forEach((c) => {
        c.querySelector('img').style.maxHeight = this.sizeFiles({
          name: this.product.name,
          typo: this.product.typo.name,
          color: this.product.color.hexa,
          width: this.product.width.value,
        });
      });
    },
  },
};
</script>
